import { roleService } from "@features/role/RoleService";
import { RoleOutputDTO } from '@features/role/types';
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: RoleReducer,
  actions: RoleActions,
  fetchAll: fetchRoles,
  fetchById: fetchRoleById,
  createEntity: createRole,
  updateEntity: updateRole,
  deleteEntity: deleteRole,
} = createEntitySlice<RoleOutputDTO>("Role", roleService);

export {
  RoleReducer,
  RoleActions,
  fetchRoles,
  fetchRoleById,
  createRole,
  updateRole,
  deleteRole,
}; 